module.exports = __webpack_public_path__ + "img/20220208_130344.75327131.jpg";